import { Paper, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import CommentsTab from "./CommentsTab";
import ContactsTab from "./ContactsTab";
import { MemoryMessage } from "../hooks/useMemoryMessages";
import TributeBookTab from "./TributeBookTab";

interface MemoryTableContentProps {
  messages: MemoryMessage[];
  isLoading?: boolean;
  onStatsChange?: () => void;
  activeTab: number;
  onTabChange: (tab: number) => void;
  streamId: number | null;
  deceasedName?: string;
  streamLink?: string;
}

export default function MemoryTableContent({
  messages,
  isLoading,
  onStatsChange,
  activeTab,
  onTabChange,
  streamId,
  deceasedName,
  streamLink,
}: MemoryTableContentProps) {
  const [commentsCount, setCommentsCount] = useState(messages.length);

  return (
    <Paper
      sx={{
        flex: 1,
        borderRadius: 3,
        p: 2.5,
        boxShadow: 0,
        border: "1px solid #f1f5f9",
      }}
    >
      <Tabs
        value={activeTab}
        onChange={(_, v) => onTabChange(v)}
        sx={{
          mb: 2.5,
          borderBottom: "1px solid #f1f5f9",
          "& .MuiTab-root": {
            textTransform: "none",
            fontWeight: 600,
            fontSize: "14px",
            color: "text.secondary",
            minWidth: "unset",
            px: 0,
            mr: 3,
          },
          "& .Mui-selected": { color: "#724e41" },
          "& .MuiTabs-indicator": { bgcolor: "#724e41" },
        }}
      >
        <Tab label={`Comments ${commentsCount > 0 ? commentsCount : ""}`} />
        <Tab label="Contacts" />
        <Tab label="Tribute Book" />
      </Tabs>
      {activeTab === 0 && (
        <CommentsTab
          messages={messages}
          isLoading={isLoading}
          onCountChange={setCommentsCount}
          onStatsChange={onStatsChange}
        />
      )}

      {activeTab === 1 && (
        <ContactsTab
          messages={messages}
          streamId={streamId}
          deceasedName={deceasedName}
          streamLink={streamLink}
        />
      )}

      {activeTab === 2 && (
        <TributeBookTab deceasedName={deceasedName} streamId={streamId} />
      )}
    </Paper>
  );
}
